<template>
  <div class="content">
    <CustomTable v-loading="loading" :headerData="headerData" :btnsData="btnsData" :data="data" @init="init"
      :hasPagination="false" :hasBtns="false" @handelBtnClick="handelBtnClick">
      <el-table-column label="操作" fixed="right" align="center" width="100px">
        <template slot-scope="scope">
          <el-link @click="handelTableClick(scope.row, 'edit')">编辑</el-link>
          <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'delete')">
            <el-link slot="reference">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </CustomTable>
    <el-dialog title="新增" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
    </el-dialog>
  </div>
</template>
  
<script>
import CustomForm from "@/components/custom/CustomForm";
import CustomTable from "@/components/custom/CustomTable";
export default {
  components: { CustomForm, CustomTable },
  data() {
    return {
      headerData: [
        { label: "标题", prop: "title", value: "" },
        { label: "跳转链接", prop: "linkUrl", value: "" },
        { label: "图片", prop: "url", value: "", type: "image" },
      ],
      btnsData: [{ label: "新增", value: "add", type: "primary" }],
      data: [],
      addFormData: [
        {
          label: "标题",
          prop: "title",
          type: "input",
          value: "",
          span: 24,
          required: true,
        },
        {
          label: "跳转链接",
          prop: "linkUrl",
          type: "input",
          value: "",
          span: 24,
          required: true,
        },
        {
          label: "图片",
          prop: "imgUrl",
          type: "upload",
          value: [],
          span: 24,
          required: true,
        },
      ],
      selectData: {},
      loading: false,
      createdType: "",
      dialogVisible: false,
    };
  },
  methods: {
    handelForm(data) {
      if (!data) {
        this.dialogVisible = false;
        return;
      }
      let params = Object.assign({}, data);
      params.imgUrl = params.imgUrl[0];
      const url =
        this.createdType == "add"
          ? this.$api.ContentManagement.linksAdd
          : this.$api.ContentManagement.linksUpdate + this.selectData.id;
      this.$https.post(url, params).then((res) => {
        this.$message.success(
          this.createdType == "add" ? "新增成功" : "修改成功"
        );
        this.dialogVisible = false;
        this.init();
      });
    },
    handelTableClick(data, type) {
      this.createdType = type;
      switch (type) {
        case "delete":
          this.$https
            .post(this.$api.ContentManagement.linksDelete + data.id)
            .then((res) => {
              this.$message.success("删除成功");
              this.init();
            });
          break;
        case "edit":
          this.selectData = data;
          this.addFormData = this.addFormData.map((el) => {
            return Object.assign(el, {
              value:
                el.prop == "imgUrl"
                  ? [data[el.prop]]
                  : data[el.prop],
            });
          });
          this.dialogVisible = true;
          break;
      }
    },
    handelBtnClick(type) {
      this.createdType = type;
      switch (type) {
        case "add":
          this.addFormData = [
            {
              label: "标题",
              prop: "title",
              type: "input",
              value: "",
              span: 24,
              required: true,
            },
            {
              label: "跳转链接",
              prop: "linkUrl",
              type: "input",
              value: "",
              span: 24,
              required: true,
            },
            {
              label: "图片",
              prop: "imgUrl",
              type: "upload",
              value: [],
              span: 24,
              required: true,
            },
          ];
          this.dialogVisible = true;
          break;
      }
    },
    init(params) {
      this.loading = true;
      this.$https
        .get(this.$api.ContentManagement.linksList, params)
        .then((res) => {
          const data = res;
          this.data = data.map((el) => {
            return Object.assign(el, {
              url: el.imgUrl && this.$api.imgBaseUrl + el.imgUrl,
            });
          });
          this.loading = false;
        });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/.el-dialog__body {
  padding: 0;
}
</style>